<template>
  <div id="app-multi-select-table">
    <button class="btn btn-primary" @click="showDialogHandler">Reasons</button>
    {{this.itemsSelected}}
    <v-dialog v-model="showDialog" max-width="400px">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="details"
        :single-select="singleSelect"
        item-key="id"
        select-all
        class="elevation-1"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.native="toggleAll"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td>
              <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
            </td>
            <td>
              {{ props.item.name }}
              <input type="text" v-bind:value="props.item.id" />
              {{ props.item.id }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      showDialog: false,
      singleSelect: false,
      pagination: {
        sortBy: "name"
      },
      selected: [],
      headers: [
        { text: "Name", value: "display_name" },
        { text: "ID", value: "id" }
      ],
      details: []
    };
  },

  computed: {
    itemsSelected: function() {
      return this.selected;
    }
  },

  methods: {
    showDialogHandler() {
      this.showDialog = !this.showDialog;
    },

    getReasonListHandler() {
      const vm = this;

      axios
        .get(this.$store.getters.rootAPI + "/clock/reason/list")
        .then(function(response) {
          var reasons = [];
          reasons = response.data.rec;

          for (let i = 0; i < reasons.length; i++) {
            vm.details.push({
              id: reasons[i].id,
              name: reasons[i].display_name
            });
          }
        })
        .catch(function(error) {
          vm.status = "An error occured." + error;
        });
    },

    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.details.slice();
      }
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    selectedHandler(item) {
      this.selected = !item;
      //this.$emit("itemsWasSelected", this.selected);
    }
  },

  mounted() {
    this.getReasonListHandler();
  }
};
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh);
}
</style>


// WEBPACK FOOTER //
// src/components/shared/ReasonSelectDialog.vue